module.exports = __webpack_public_path__ + "static/media/WhitePineJustName.04f88f4c.svg";